import React from 'react';
import { Form, CheckBox, TextAreaBox } from 'fw/forms';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { Label, Button } from 'fw/components';
import { ContentBody, VeteranAppIdHeader } from 'areas/shared/components';
import { DocumentUpload } from 'areas/shared/controls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import * as FormManager from 'fw/forms/form/FormManager';
import { TooltipCode } from 'areas/shared/consts';

class TaxInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState();
  }

  initialState = () => {
    return {
      loading: true,
      title: "",
      form: this.props.stepData,
      tooltips: this.props.stepInfo.tooltips
    };
  };

  updatePostData = (form, dirty) => {
    this.handleUploadsNotApplicableChange(form);
    this.setState({ form });
    this.props.onStepChange(form);

    if (dirty === true)
      FormManager.dirt(this._form);
  }

  handleUploadsNotApplicableChange = (form) => {
    //check businessTax1UploadDocument
    if (form.businessTax1 !== this.state.form.businessTax1) {
      this._businessTax1.blankFile(0);
      form.businessTax1StorageToken = this._businessTax1.state.storageToken;
      form.businessTax1FileName = this._businessTax1.state.fileName;
    }
    //check businessTax2UploadDocument
    if (form.businessTax2 !== this.state.form.businessTax2) {
      this._businessTax2.blankFile(0);
      form.businessTax2StorageToken = this._businessTax2.state.storageToken;
      form.businessTax2FileName = this._businessTax2.state.fileName;
    }
    //check personalTax1UploadDocument
    if (form.personalTax1 !== this.state.form.personalTax1) {
      this._personalTax1.blankFile(0);
      form.personalTax1StorageToken = this._personalTax1.state.storageToken;
      form.personalTax1FileName = this._personalTax1.state.fileName;
    }
    //check personalTax2UploadDocument
    if (form.personalTax2 !== this.state.form.personalTax2) {
      this._personalTax2.blankFile(0);
      form.personalTax2StorageToken = this._personalTax2.state.storageToken;
      form.personalTax2FileName = this._personalTax2.state.fileName;
    }
  }

  handleUploadChange = (file, field) => {
    let form = this.state.form;
    form[field + 'StorageToken'] = file.storageToken;
    form[field + 'FileName'] = file.fileName;

    this.updatePostData(form, true);
  };

  addAnotherTaxDocument = (e) => {
    e.preventDefault();
    let form = this.state.form;

    form.otherFiles.push({
      taxInformationOtherFileId: -Math.abs(Date.now() | 0)
    });

    this.updatePostData(form);
  };

  handleOtherDocumentRemove = (index) => {
    let form = this.state.form;

    form.otherFiles[index].description = "";
  };

  handleUploadOtherDocumentChange = (file, index) => {
    let form = this.state.form;
    form.otherFiles[index].storageToken = file.storageToken;
    form.otherFiles[index].fileName = file.fileName;

    this.updatePostData(form, true);
  };

  handleDescriptionChange = (value, index) => {
    let form = this.state.form;
    form.otherFiles[index].description = value;

    this.updatePostData(form, true);
  };

  handleRemoveOtherDocument = (e, i) => {
    e.preventDefault();
    let form = this.state.form;
    form.otherFiles.splice(i, 1);

    this.updatePostData(form, true);
  }

  renderOtherFiles = () => {
    return this.state.form.otherFiles.map((item, index) => (
      <Row key={item.taxInformationOtherFileId} style={{ marginBottom: 10 }}>
        <Col md={11}>
          <DocumentUpload
            disabled={this.props.stepInfo.isRenewal}
            storageToken={item.storageToken}
            fileName={item.fileName}
            onChange={file => this.handleUploadOtherDocumentChange(file, index)}
            onRemove={() => this.handleOtherDocumentRemove(index)}
          />
          <TextAreaBox
            disabled={this.props.stepInfo.isRenewal}
            rows={3}
            value={item.description}
            placeholder='Briefly describe your Uploaded Tax Document here...'
            maxLength={500}
            onChange={value => this.handleDescriptionChange(value, index)}
          />
        </Col>
        <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -15, paddingLeft: 0 }}>
			<Button type="button" bsStyle="link" onClick={(e) => this.handleRemoveOtherDocument(e, index)} title="Remove Financial Document">
            	<FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
			</Button>
        </Col>
      </Row>
    ));
  };

  setTip = (property) => {
    const tooltip = this.state.tooltips.find(t => t.code === property)
    return tooltip !== undefined ? tooltip.tip : null
  }

  render() {
    return (
      <Form
        onChange={this.updatePostData}
        values={this.state.form}
        unsavedChangesWarning={true}
        disabled={this.props.stepInfo.readonly}
        ref={(form) => { this._form = form }}>
        <div>
          <ContentBody>
            <Row>
              <Col md={12}>
                <Row>
                  <Col md={12}>
                    <h3 style={{ position: 'relative' }}>Tax Information – <small>Please submit all required Tax documents</small> <VeteranAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.stepInfo.daysOpen} /></h3>
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label htmlFor="businessLetter" tip={this.setTip(TooltipCode.TAX.BIZLETTER)} required>Previous Year Business Federal Tax Return or IRS Extension Acceptance Letter</Label>
                      <DocumentUpload
                        storageToken={this.state.form.businessTax1StorageToken}
                        fileName={this.state.form.businessTax1FileName}
                        onChange={file => this.handleUploadChange(file, 'businessTax1')}
                        disabled={this.props.stepInfo.isRenewal}
                        ref={(c) => { this._businessTax1 = c; }}
                      />
                      <CheckBox inline name='businessTax1' label='Not applicable to my Business'
                        disabled={this.props.stepInfo.isRenewal} />
                      {this.state.form !== null && this.state.form.businessTax1 ? (
                        <p>
                          Please provide a Letter of Explanation on a Corporate Letterhead that is signed and dated as to why it cannot be provided, and upload it in the field above
                        </p>
                      ) : null}
                    </FormGroup>
                    {this.state.form.secondYear ? (
                      <FormGroup>
                        <Label htmlFor="priorBusinessLetter" tip={this.setTip(TooltipCode.TAX.PRIORBIZLETTER)} required>Prior to Previous Year Business Federal Tax Return or IRS Extension Acceptance Letter</Label>
                        <DocumentUpload
                          disabled={this.props.stepInfo.isRenewal}
                          storageToken={this.state.form.businessTax2StorageToken}
                          fileName={this.state.form.businessTax2FileName}
                          onChange={file => this.handleUploadChange(file, 'businessTax2')}
                          ref={(c) => { this._businessTax2 = c; }}
                        />
                        <CheckBox inline name='businessTax2' label='Not applicable to my Business'
                          disabled={this.props.stepInfo.isRenewal} />
                        {this.state.form !== null && this.state.form.businessTax2 ? (
                          <p>
                            Please provide a Letter of Explanation on a Corporate Letterhead that is signed and dated as to why it cannot be provided, and upload it in the field above
                            </p>
                        ) : null}
                      </FormGroup>
                    ) : null}
                    <FormGroup>
                      <Label htmlFor="personalLetter" tip={this.setTip(TooltipCode.TAX.PERSLETTER)} required>Previous Year Personal Federal Tax Return or IRS Extension Acceptance Letter</Label>
                      <DocumentUpload
                        disabled={this.props.stepInfo.isRenewal}
                        storageToken={this.state.form.personalTax1StorageToken}
                        fileName={this.state.form.personalTax1FileName}
                        onChange={file => this.handleUploadChange(file, 'personalTax1')}
                        ref={(c) => { this._personalTax1 = c; }}
                      />
                      <CheckBox inline name='personalTax1' label='Not applicable' disabled={this.props.stepInfo.isRenewal} />
                      {this.state.form !== null && this.state.form.personalTax1 ? (
                        <p>
                          Please provide a Letter of Explanation on a Corporate Letterhead that is signed and dated as to why it cannot be provided, and upload it in the field above
                        </p>
                      ) : null}
                    </FormGroup>
                    {this.state.form.secondYear ? (
                      <FormGroup>
                        <Label htmlFor="priorPersonalLetter" tip={this.setTip(TooltipCode.TAX.PRIORPERSLETTER)} required>Prior to Previous Year Personal Federal Tax Return or IRS Extension Acceptance Letter</Label>
                        <DocumentUpload
                          disabled={this.props.stepInfo.isRenewal}
                          storageToken={this.state.form.personalTax2StorageToken}
                          fileName={this.state.form.personalTax2FileName}
                          onChange={file => this.handleUploadChange(file, 'personalTax2')}
                          ref={(c) => { this._personalTax2 = c; }}
                        />
                        <CheckBox inline name='personalTax2' label='Not applicable' disabled={this.props.stepInfo.isRenewal} />
                        {this.state.form !== null && this.state.form.personalTax2 ? (
                          <p>
                            Please provide a Letter of Explanation on a Corporate Letterhead that is signed and dated as to why it cannot be provided, and upload it in the field above
                            </p>
                        ) : null}
                      </FormGroup>
                    ) : null}
                  </Col>
                  <Col md={1} />
                  <Col md={6}>
                    <Row>
                      <Col md={12}>
                        <label>&nbsp;</label>
                        {this.state.form.otherFiles != null && this.state.form.otherFiles.length > 0 && this.renderOtherFiles()}
                        {(this.state.form.otherFiles == null || this.state.form.otherFiles.length < 5) &&
							<Button type="button" bsStyle="link" onClick={(e) => this.addAnotherTaxDocument(e)}>
								Add another Tax Document
							</Button>
						}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </ContentBody>
        </div>
      </Form>
    );
  }
}

export default TaxInfo;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/taxInfo/TaxInfo.js